import { RootStore } from "../root.store"

export const createStore = (): RootStore => new RootStore()
